import { ErrorHandler, Injectable, inject } from '@angular/core';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { captureException } from './sentry';

const RELOAD_KEY = 'rp_chunk_reload';
const RELOAD_COOLDOWN_MS = 10_000;

@Injectable()
export class ChunkErrorHandler implements ErrorHandler {
  private platformId = inject(PLATFORM_ID);

  handleError(error: unknown): void {
    if (isPlatformBrowser(this.platformId) && isChunkLoadError(error)) {
      const last = Number(sessionStorage.getItem(RELOAD_KEY) || '0');
      if (Date.now() - last > RELOAD_COOLDOWN_MS) {
        sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
        window.location.reload();
        return;
      }
    }
    captureException(error);
    console.error(error);
  }
}

function isChunkLoadError(err: unknown): boolean {
  if (!err) return false;
  const msg = ((err as any)?.message ?? '').toLowerCase();
  const name = ((err as any)?.name ?? '');
  if (name === 'ChunkLoadError') return true;
  if (msg.includes('loading chunk') || msg.includes('loading css chunk')) return true;
  if (msg.includes('failed to fetch dynamically imported module')) return true;
  const rejection = (err as any)?.rejection;
  if (rejection) return isChunkLoadError(rejection);
  return false;
}
